import { useState } from "react";

type Value = string;
type ValidationError = string;
interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
type Field = [Value, ValidationError | null, Props];

export default (
  validator: (value: Value) => ValidationError | null = () => null,
): Field => {
  const [value, setValue] = useState("");
  const [error, setError] = useState<null | string>(null);

  return [
    value,
    error,
    {
      value,
      onChange: (e) => {
        setValue(e.target.value);
        setError(validator(e.target.value));
      },
    },
  ];
};
